import React from "react";

function support() {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center position-relative">
     <div className="card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        <div className="mb-2">
        <h2 className="form_title_uppercase text-color">SUPPORT TICKETS</h2>
        </div>
        <div className="ticket-alert-box">
          <h5
            className="  text-white p-2 fs-5 ticket-title"
            style={{ backgroundColor: "#c8605e" }}
          >
            INMATES, FRIENDS, FAMILY AND MEDIA INQUIRIES
          </h5>
          <div className="card-body ticket-content">
            <label className="fs-5">
              If the inmate, their family, or any other public end-user or media
              outlet has questions or concerns, please direct them to our public
              customer support email:{" "}
              <span>
                <a
                  href="mailto:support@inmateinbox.com"
                  className="ml-1 text-primary"
                >
                  support@inmateinbox.com
                </a>
              </span>
            </label>
          </div>
        </div>

        <div className="ticket-alert-box">
          <h5
            className="  text-white p-2 fs-5 ticket-title"
            style={{ backgroundColor: "#c8605e" }}
          >
            INTERNAL JAIL SUPPORT
          </h5>
          <div className="card-body ticket-content">
            <label className="fs-5">
              For internal support for software or maintenance on the kiosk
              hardware, please call
              <span>
                {" "}
                <a href="tel:877-711-6379" className="ml-1 text-primary">
                  877-711-6379
                </a>
              </span>
              . This internal contact information is not to be distributed to
              the public.
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default support;
